import { Component, ChangeDetectionStrategy, signal } from '@angular/core';

interface Contact {
  name: string;
  avatarId: string;
}

@Component({
  selector: 'app-quick-transfer',
  templateUrl: './quick-transfer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickTransferComponent {
  contacts = signal<Contact[]>([
    { name: 'Robert Fox', avatarId: '1012' },
    { name: 'Jerome Bell', avatarId: '1027' },
    { name: 'Brooklyn S.', avatarId: '1005' },
    { name: 'Cameron W.', avatarId: '1011' },
  ]);

  selectedContact = signal<Contact | null>(this.contacts()[0]);

  selectContact(contact: Contact): void {
    this.selectedContact.set(contact);
  }
}
